module.exports = __webpack_public_path__ + "static/img/logo3.7cf6124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo3.png
// module id = 116
// module chunks = 10